import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, Signal, signal, WritableSignal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { SvgComponent } from '../../svg/svg.component';
import { attachmentTypes } from '@app/_datas/const.data';
import { AttachmentType } from '@app/_types/generic.type';
import { MapService } from '@app/_services/map.service';
import { SettingsService } from '@app/_services/settings.service';
import { InputCheckboxComponent } from '../../inputs/input-checkbox/input-checkbox.component';
import { AnalyticsService } from '@app/_services/analytics.service';

@Component({
    selector: 'app-filter-attachment',
    imports: [
        CommonModule,
        MatMenuModule,
        SvgComponent,
        InputCheckboxComponent
    ],
    templateUrl: './filter-attachment.component.html',
    styleUrl: './filter-attachment.component.scss'
})

export class FilterAttachmentComponent implements OnInit {

  @Input() signal: WritableSignal<AttachmentType[]> = signal<AttachmentType[]>([]);
  @Input() multiple: boolean = false;
  attachmentTypes: AttachmentType[] = attachmentTypes;
  attachmentMap: Signal<Record<AttachmentType, string>> = this.mapService.attachmentTypeMap;

  @Output() select = new EventEmitter<string[]>();

  // Local optimistic state — updates instantly on click, independent of store propagation
  selectedItems = signal<AttachmentType[]>([]);

  constructor(public ss: SettingsService, private mapService: MapService, private as: AnalyticsService) {

  }

  ngOnInit(): void {
    this.selectedItems.set(this.signal());
  }

  getLabel(): string {
    if (this.selectedItems().length === 0) {
      return this.ss.t('common_attachment');
    } else if (this.selectedItems().length === 1) {
      return this.attachmentMap()[this.selectedItems()[0]];
    } else {
      return this.selectedItems().length + ' ' + this.ss.t('common_attachment');
    }
  }

  onSelected(value: AttachmentType, event: MouseEvent): void {
    this.as.filterEvent('attachments', value);
    if (this.multiple) {
      const current = this.selectedItems();
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      // Update local state immediately (optimistic)
      this.selectedItems.set(updated);
      // Update store — triggers data reload in background
      this.signal.set(updated);
      this.select.emit();
      event.stopPropagation();
    } else {
      this.selectedItems.set([value]);
      this.signal.set([value]);
      this.select.emit();
    }
  }

}
